import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { SOCKET_URL, IMGS_URL } from '../../../config';
import { Box, Typography } from '@mui/material';

const socket = io(SOCKET_URL);

const Home = () => {
  const [repStatus, setRepStatus] = useState([]);

  useEffect(() => {
    // ✅ Połączenie WebSocket i nasłuchiwanie zdarzenia "newTask"
    socket.on('newReportPZ04', (reportPZ04) => {
      console.log('Otrzymano nowy raport PZ04:', reportPZ04);
      // 🔁 Aktualizacja stanu komponentu
      setRepStatus((prevStatus) => [
        ...prevStatus,
        `Nowy raport PZ04: ${reportPZ04.reportNumber}`,
      ]);

      // setRepStatus(`Nowy raport PZ04: ${reportPZ04.reportNumber}`);

      const audio = new Audio('/sounds/notification.mp3'); // Ścieżka do pliku dźwiękowego
      audio.play().catch((error) => {
        console.error('Błąd odtwarzania dźwięku:', error);
      });
    });

    return () => {
      socket.off('newReportPZ04'); // 🔁 Wyczyść po odmontowaniu
    };
  }, []);
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: 'calc(100vh - 64px)', // jeśli masz AppBar 64px (dostosuj, jeśli trzeba)
        px: 3,
        py: 3,
        backgroundImage: `url(${IMGS_URL}/AMBF_LOGO.png)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: { xs: '80%', sm: '60%', md: '40%' },
        // watermark efekt:
        backgroundColor: 'transparent',
      }}
    >
      {/* Warstwa przygaszająca logo (opcjonalnie, daje lepszą czytelność treści) */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(255,255,255,0.92)', // zmniejsz/usuń jeśli chcesz mocniejsze logo
          zIndex: 0,
        }}
      />

      {/* Treść na wierzchu */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="h4" gutterBottom>
          Home Page
        </Typography>

        <Typography variant="h6" sx={{ mt: 3 }}>
          Lista nowych Raportów PZ04:
        </Typography>

        <ul>
          {repStatus.map((status, index) => (
            <li key={index}>{status}</li>
          ))}
        </ul>
      </Box>
    </Box>
  );
};
export default Home;
